// redux/slices/counterSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { roleReducer } from "../Reducer/roleReducer";

const initialState = {

    loading: false,
    roles: [],
    error: null,
    isRoleUpdated: true,
    modules:[],
    moduleLoading:false,

};
const roleSlice = createSlice({
    name: "role",
    initialState,
    reducers: {

    },
    extraReducers: (builder) => {
        roleReducer(builder);
    },
});

export const { } = roleSlice.actions;
export default roleSlice.reducer;
